import React from 'react';

import { CaseStudies, PageTitle } from '../../../components';



const CasePage = () => {
 
  return ( 
    <>  
      {/* Page Title */}
      <PageTitle title={'Case Studies'} page={'Case Studies'} />

      {/* Case Studies Section */}
      <section>
        < CaseStudies/>
      </section>
    </>
  );
  
}

export default CasePage;